import Cookies from 'js-cookie';

const config = {
	keyDefault: 'AllowTrackingCookies',
	expires: 365,
	path: '/',
	secure: true,
	sameSite: 'None',

	getCookieName(cookieName) {
		return cookieName || this.keyDefault;
	},

	get({ cookieName }) {
		const name = this.getCookieName(cookieName);

		return Cookies.get(name);
	},

	set({ cookieName }, value) {
		if (!['true', 'false'].includes(value)) {
			console.warn(`Invalid cookie value (${value})`);

			return;
		}

		const name = this.getCookieName(cookieName);
		const { expires, path, secure, sameSite } = this;

		Cookies.set(name, value, { expires, path, secure, sameSite });
	},

	remove({ cookieName }) {
		const name = this.getCookieName(cookieName);

		Cookies.remove(name);
	},
};

export default config;

